import ModalDialog from '@ui/modal/ModalDialog';
import React from 'react';
import { useTranslation } from 'react-i18next';
const ShippingLimitations = (props) => {
    const { t } = useTranslation();
    return (React.createElement(ModalDialog, { className: "modal--centered", isOpen: props.open, onRequestClose: props.onRequestClose, contentLabel: t('checkout.shipping.limitationstitle') },
        React.createElement("div", { dangerouslySetInnerHTML: { __html: t('checkout.shipping.limitations') } })));
};
export default ShippingLimitations;
